module.exports = __webpack_public_path__ + "media/images/alerta_parada-f05fb122830d29781aa9319929300c29.jpg";